import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <div className="border-b border-black/10 py-8">
    <h2 className="font-semibold text-xl text-[#111418] mb-3">{title}</h2>
    <div className="text-black/60 text-sm leading-relaxed flex flex-col gap-3">{children}</div>
  </div>
);

export const Terminos = () => {
  useEffect(() => {
    document.title = "Términos y condiciones - Ruta 360";
  }, []);

  return (
    <div data-testid="terminos-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[100px]">
        <div className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <h1 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418] mb-10">
              Términos y condiciones
            </h1>

            <Section title="Quiénes somos">
              <p>
                Ruta 360 (Ruta Deportiva 360), punto de distribución en Xalapa, Veracruz, México. Contacto:
                WhatsApp +52 1 228 408 1782 y pescadeportivamx@gmail.com.
              </p>
            </Section>

            <Section title="Precios">
              <p>
                Todos los precios están en pesos mexicanos (MXN). Pueden cambiar sin previo aviso, pero respetamos el
                precio que tenías al momento de pagar.
              </p>
            </Section>

            <Section title="Disponibilidad">
              <p>
                Si un producto se agota después de tu pago, te avisamos y te ofrecemos otro producto o el reembolso
                completo.
              </p>
            </Section>

            <Section title="Pagos">
              <p>
                Aceptamos Mercado Pago, PayPal y pago contra entrega en Xalapa. Tus datos de tarjeta los
                procesa la plataforma de pago; nunca pasan por nuestra página.
              </p>
            </Section>

            <Section title="Envíos">
              <p>
                Enviamos a todo México con FedEx, Estafeta, DHL o Mercado Libre. Tiempos de entrega: Veracruz y estados vecinos
                1 a 3 días; resto de México 3 días; ejidos y zonas de difícil acceso 3 a 7 días. Te compartimos tu
                número de guía por WhatsApp o correo y te avisamos cuando tu pedido esté por llegar. El envío es
                gratis en compras desde $1,399 MXN; en compras menores el envío cuesta $99 MXN.
              </p>
            </Section>

            <Section title="Cupón de bienvenida">
              <p>10% de descuento en productos (no aplica al envío), válido en tu primera compra al pagar en rutadeportiva360.com.</p>
            </Section>

            <Section title="Cambios y garantía">
              <p>
                Consulta nuestra página de{" "}
                <Link to="/devoluciones" className="underline underline-offset-2 text-[#FF5508] hover:text-black transition-colors">
                  Cambios, devoluciones y garantía
                </Link>
                .
              </p>
            </Section>

            <Section title="Privacidad">
              <p>
                El uso de tus datos se rige por nuestro{" "}
                <Link to="/privacidad" className="underline underline-offset-2 text-[#FF5508] hover:text-black transition-colors">
                  Aviso de privacidad
                </Link>
                .
              </p>
              <p className="text-xs text-black/40">Última actualización: octubre de 2026.</p>
            </Section>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
